
import ContactForm from '../../components/ContactForm'
import MainHeader from '../../components/MainHeader'
import Values from '../../components/Values'
// import Imageswiper from '../../components/Imageswiper'

import './home.css'

const Home = () => {
  return (
    <>
    <MainHeader/>
    <ContactForm/>
    <Values/>
    {/* <Imageswiper/> */}
    </>
  )
}

export default Home